module.exports = __webpack_public_path__ + "img/grade-stroke.bbfb94cc.png";